// extracted by mini-css-extract-plugin
export default {"suggestion":"styles_suggestion__CKtpK","active":"styles_active__BSUFB","icon":"styles_icon__G7mf2","description":"styles_description__hh88+"};